import React, { Component } from "react"
import { Row, Col, FormGroup } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"

class FormEdit extends Component {
  // constructor(props) {
  //   super(props)
  // }
  
  // componentDidMount() { }

  render() {
    const profile = this.props.profileData
    return (
      <AvForm id='my-form' onValidSubmit={ this.props.handleValidEmployeeSubmit }>
        <FormGroup className="mb-3">
          <AvField
              name="fname"
              label="First Name"
              type="text"
              errorMessage="Invalid name"
              validate={{
              required: { value: true },
              }}
              value={ profile.fname }
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <AvField
              name="sname"
              label="Last Name"
              type="text"
              errorMessage="Invalid name"
              validate={{
              required: { value: true },
              }}
              value={ profile.sname }
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <AvField
              name="workEmail"
              label="Contact Email"
              type="email"
              errorMessage="Invalid email"
              validate={{
              required: { value: true },
              }}
              value={ profile.workEmail }
          />
        </FormGroup>

        <Row>
          <Col md={4}>
            <FormGroup className="mb-3">
              <AvField
                name="mobPhoneOne"
                label="Phone №"
                type="text"
                errorMessage="Invalid number"
                validate={{
                required: { value: true },
                }}
                value={ profile.mobPhoneOne }
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="mb-3">
              <AvField
                name="deskPhone"
                label="Desk №"
                type="text"
                errorMessage="Invalid number"
                validate={{
                required: { value: true },
                }}
                value={ profile.deskPhone }
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="mb-3">
              <AvField
                name="mobPhoneTwo"
                label="Personal №"
                type="text"
                value={ profile.mobPhoneTwo }
              />
            </FormGroup>
          </Col>
        </Row>

        <FormGroup className="mb-3">
          <AvField
            name="persEmail"
            label="Personal email"
            type="email"
            value={ profile.persEmail }
          />
        </FormGroup>
      </AvForm>
    )
  }
}

export default FormEdit